import React, { useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { 
  getCGSmartfrenURL, 
  setFirstloadFlag, 
  deleteFirstloadFlag, 
  // storeTransID,
  postSFTransID } from '../../redux/actions/smartfren'
import { generateTransID, checkCookie } from '../../utils'

const closeInterval = 10000;

const SmartfrenWrapper = ({ children }) => {
  const isDeveloper = checkCookie("KBEV1MWHZ4")
  const dispatch = useDispatch()

  const callCG = useCallback(() => {
    const transID = generateTransID()
    const url = dispatch(getCGSmartfrenURL(transID))
    const windowParams = isDeveloper ? 
      'width=300, height=300' :
      'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=100000, top=100000, width=2, height=2, visible=none'
    window.open(url, "__blank", windowParams, '')
    // dispatch(storeTransID(transID))
    setTimeout(() => {
      dispatch(postSFTransID(transID))
    }, closeInterval)
  }, [dispatch, isDeveloper])

  const smartfrenAutologin = useCallback(() => {
    const GFFirstLoad = localStorage.getItem("GFFirstLoad")
    const GFtoken = localStorage.getItem("gfToken")
    const GFLoggedOut = localStorage.getItem("gfLoggedOut")
    const flag = JSON.parse(GFFirstLoad)
    const flagLoggedout = JSON.parse(GFLoggedOut)
    if (flag && !GFtoken && !flagLoggedout) {
      dispatch(deleteFirstloadFlag())
      callCG()
    }
    if (flagLoggedout) localStorage.removeItem("gfLoggedOut")
  }, [callCG, dispatch])

  const onBeforeUnload = useCallback(() => {
    dispatch(setFirstloadFlag())
  }, [dispatch])

  useEffect(() => {
    window.addEventListener("beforeunload", onBeforeUnload)
    window.addEventListener("load", smartfrenAutologin)
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload)
      window.removeEventListener("load", smartfrenAutologin)
    }
  }, [onBeforeUnload, smartfrenAutologin])

  // return <>
  //   {children}
  //   {sfUrl && (<iframe src={sfUrl} title="SFRedirection" 
  //     style={{ width: isDeveloper ? 300 : 0, height: isDeveloper ? 300 : 0, border: isDeveloper ? '1px solid white' : 'none'}}>
  //   </iframe>)}
  // </>
  return children
}

export default React.memo(SmartfrenWrapper)